module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n        #" + _vm._s(_vm.model.order_number) + "\n        "), _c('small', {
    staticClass: "order__time"
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.model.ordered_on)))])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 16
    }
  }, [(_vm.model.order_items) ? _c('div', [(_vm.hasSku) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.model.order_items,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "image",
      "label": "Image"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.image) ? _c('div', [_c('img', {
          attrs: {
            "src": scope.row.image,
            "width": "40"
          }
        })]) : _vm._e()]
      }
    }], null, false, 813630063)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sku",
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row) ? _c('div', [(
          scope.row.meta_data &&
          scope.row.meta_data.name
        ) ? _c('span', [_vm._v(_vm._s(scope.row.meta_data.name)), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "label-lg"
        }, [_vm._v(_vm._s(scope.row.sku))]), _vm._v(" "), (
          scope.row.selected_products &&
          scope.row.meta_data &&
          scope.row.meta_data.properties &&
          _vm.isDynamicPackage(
            scope.row.meta_data.properties
          )
        ) ? _c('div', {
          staticClass: "mt-5"
        }, [_c('strong', [_vm._v("Included products:")]), _vm._v(" "), _vm._l((scope.row.selected_products), function(selectedProduct, index) {
          return _c('div', {
            key: selectedProduct.id + index
          }, [_c('span', [_vm._v(_vm._s(selectedProduct.name))]), _c('br'), _c('span', {
            staticClass: "label-lg"
          }, [_vm._v(_vm._s(selectedProduct.sku))])])
        })], 2) : _vm._e(), _vm._v(" "), (
          scope.row.selected_products &&
          scope.row.meta_data &&
          scope.row.meta_data.properties &&
          _vm.isDynamicPricePackage(
            scope.row.meta_data.properties
          )
        ) ? _c('div', {
          staticClass: "mt-5"
        }, [_c('strong', [_vm._v("Included products:")]), _vm._v(" "), _vm._l((scope.row.selected_products), function(selectedProduct, index) {
          return _c('div', {
            key: selectedProduct.id + index
          }, [_vm._v("\n                                        " + _vm._s(selectedProduct.name) + " (" + _vm._s(_vm._f("currency")(selectedProduct.price,
            selectedProduct.currency +
            ' '
          )) + ")\n                                    ")])
        })], 2) : _vm._e()]) : _vm._e()]
      }
    }], null, false, 996529527)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row && scope.row.value) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(scope.row.value, _vm.model.currency + ' ')) + "\n                            ")]) : _vm._e()]
      }
    }], null, false, 1536985407)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Quantity",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_price",
      "label": "Total",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row) ? _c('div', [(
          scope.row.meta_data &&
          scope.row.meta_data.properties &&
          _vm.isDynamicPricePackage(
            scope.row.meta_data.properties
          )
        ) ? _c('div', [(
          scope.row.total_value &&
          scope.row.discount
        ) ? _c('div', [_vm._v("\n                                        " + _vm._s(_vm._f("currency")((scope.row.total_value -
            Math.abs(
              scope.row.discount
            )),
          _vm.model.currency + ' '
        )) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (scope.row.total_value) ? _c('div', {
          staticClass: "text-zinc-400"
        }, [_c('del', [_vm._v(_vm._s(_vm._f("currency")(scope.row.total_value,
          _vm.model.currency + ' '
        )))])]) : _vm._e(), _vm._v(" "), (scope.row.discount) ? _c('div', [_c('strong', [_vm._v("Your savings:")]), _c('br'), _vm._v(_vm._s(_vm._f("currency")(Math.abs(scope.row.discount),
          _vm.model.currency + ' '
        )) + "\n                                    ")]) : _vm._e()]) : (scope.row.total_value) ? _c('div', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(scope.row.total_value, _vm.model.currency + ' ')) + "\n                                ")]) : _vm._e()]) : _vm._e()]
      }
    }], null, false, 1429764037)
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.hasSku) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.model.order_items,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "meta_data",
      "label": "Product Info"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.contents) ? _c('div', [_vm._v("\n                                " + _vm._s(scope.row.contents.sku) + " -\n                                " + _vm._s(scope.row.contents.name) + "\n                            ")]) : _vm._e()]
      }
    }], null, false, 207270700)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Quantity",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_price",
      "label": "Total",
      "width": "180"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-table"
  }, [_c('div', {
    staticClass: "el-table__footer-wrapper"
  }, [_c('table', {
    staticClass: "el-table__footer",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("\n                                        Subtotal\n                                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.subtotal,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("\n                                        Shipping\n                                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.shipping,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("\n                                        Discount\n                                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.coupon_discount,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])]), _vm._v(" "), (
    _vm.model.applied_coupons &&
    _vm.model.applied_coupons.length
  ) ? _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("\n                                        Applied coupons\n                                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, _vm._l((_vm.model.applied_coupons), function(coupon) {
    return _c('div', {
      key: coupon.id
    }, [_vm._v("\n                                            " + _vm._s(coupon.name) + " (ID:\n                                            " + _vm._s(coupon.id) + ")\n                                        ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("Tax")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.tax,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "is-leaf"
  }, [_c('div', {
    staticClass: "cell text-right"
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "is-leaf",
    attrs: {
      "width": "180"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.model.total,
    _vm.model.currency + ' '
  )) + "\n                                    ")])])])])])])]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "order__subhead"
  }, [_vm._v("History")]), _vm._v(" "), (!_vm.model.histories || !_vm.model.histories.length) ? _c('div', [_vm._v("\n                    No history yet\n                ")]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.model.histories
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Date",
      "prop": "created_at"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("datetime")(scope.row.created_at)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "prop": "action"
    }
  })], 1), _vm._v(" "), _c('h4', {
    staticClass: "order__subhead"
  }, [_vm._v("Payments")]), _vm._v(" "), (!_vm.model.payments || !_vm.model.payments.length) ? _c('div', [_vm._v("\n                    No payments yet\n                ")]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.model.payments
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Date",
      "prop": "created_at"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("datetime")(scope.row.created_at)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "prop": "status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Module",
      "prop": "module"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8
    }
  }, [_c('dl', {
    staticClass: "dl"
  }, [_c('dt', [_vm._v("Status")]), _vm._v(" "), _c('dd', [_c('v-crud-select', {
    staticClass: "order__full",
    attrs: {
      "options": _vm.statuses,
      "value": _vm.model.status
    },
    on: {
      "input": _vm.onChangeInput
    }
  })], 1), _vm._v(" "), _c('dt', [_vm._v("Shipping method")]), _vm._v(" "), _c('dd', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.model.shipping_method_name))]), _vm._v(" "), _c('dt', [_vm._v("Tracking number")]), _vm._v(" "), _c('dd', [_c('el-input', {
    staticClass: "order__full",
    model: {
      value: (_vm.model.tracking_number),
      callback: function($$v) {
        _vm.$set(_vm.model, "tracking_number", $$v)
      },
      expression: "model.tracking_number"
    }
  })], 1), _vm._v(" "), (_vm.isVisible) ? [_c('dt', [_vm._v("Business Partner ID (End User)")]), _vm._v(" "), _c('dd', [_c('el-input', {
    staticClass: "order__full",
    model: {
      value: (_vm.model.ext_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "ext_id", $$v)
      },
      expression: "model.ext_id"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.showInvoice) ? [_c('dt', [_vm._v("Invoice number")]), _vm._v(" "), _c('dd', [_c('el-input', {
    staticClass: "order__full",
    model: {
      value: (_vm.model.notes),
      callback: function($$v) {
        _vm.$set(_vm.model, "notes", $$v)
      },
      expression: "model.notes"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('dd', [_c('el-button', {
    staticClass: "order__full",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), (_vm.showInvoice) ? [_c('dd', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.invoiceLoading),
      expression: "invoiceLoading"
    }],
    staticClass: "order__full",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getInvoicePdf
    }
  }, [_vm._v("Download invoice")])], 1)] : _vm._e(), _vm._v(" "), (_vm.showInvoice) ? [_c('dd', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.sendInvoiceLoading),
      expression: "sendInvoiceLoading"
    }],
    staticClass: "order__full",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendInvoicePdf
    }
  }, [_vm._v("Send invoice via e-mail")])], 1)] : _vm._e(), _vm._v(" "), _c('dt', [_vm._v("Email")]), _vm._v(" "), _c('dd', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.model.email))]), _vm._v(" "), _c('dt', [_vm._v("Address")]), _vm._v(" "), (_vm.model.ship_address) ? _c('dd', {
    staticClass: "text-sm"
  }, [_c('span', {
    staticClass: "el-button--text cursor-pointer",
    on: {
      "click": _vm.goToCustomer
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.model.ship_address.firstname) + "\n                        " + _vm._s(_vm.model.ship_address.lastname) + "\n                    ")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.model.ship_address.address1) + "\n                    " + _vm._s(_vm.model.ship_address.address2)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.model.ship_address.zip) + " " + _vm._s(_vm.model.ship_address.city)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.model.ship_address.country) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('dt', [_vm._v("Shipping Notes")]), _vm._v(" "), (_vm.model.shipping_notes) ? _c('dd', {
    staticClass: "text-sm"
  }, [_c('ul', _vm._l((_vm.model.shipping_notes), function(value, key) {
    return _c('li', [_c('em', [_vm._v(_vm._s(key) + ":")]), _vm._v(" " + _vm._s(value) + "\n                        ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('dd', [_c('el-button', {
    staticClass: "order__full",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToCustomer
    }
  }, [_vm._v("Edit Customer")])], 1)], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-649b792b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 543
// module chunks = 1